import { z } from "zod";

const translationPath =
  "page.4uSalesContract.registers.salesContractHcpInclusionRule.errors.";

const healthProgramSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.number().optional(),
  },
  { invalid_type_error: translationPath + "health_program" }
);
export const salesContractHcpInclusionRuleSchema = z
  .object({
    id: z.string().optional(),
    healthProgram: healthProgramSchema,
    enable: z.boolean(),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
  })
  .superRefine((val, ctx) => {
    if (val.endDate < val.initialDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["initialDate"],
        message: translationPath + "date",
      });
    }
  });

export type TSalesContractHcpInclusionRuleForm = z.infer<
  typeof salesContractHcpInclusionRuleSchema
>;
